import api from '@/api';

class Job {
  /**
   * Index / Get listing of jobs
   * @returns {*}
   */
  static list(params) {
    return api.get('/jobs', { params });
  }

  /**
   * Get job
   * @param jobId
   * @returns {*}
   */
  static find(jobId) {
    return api.get(`/jobs/${jobId}`);
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  static listByAssessmentType(assessmentTypeId) {
    return api.get(`/jobs/assessment-type/${assessmentTypeId}`);
  }

  /**
   * Get job properties
   * @param jobId
   * @returns {*}
   */
  static getProperties(jobId) {
    return api.get(`/jobs/${jobId}/properties`);
  }

  /**
   * Get job properties
   * @param jobId
   * @returns {*}
   */
  static getDeletedProperties(jobId) {
    return api.get(`/jobs/${jobId}/deleted-properties`);
  }
}

export default Job;
